import { Glyphicon } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import {
  EmailSearchOption,
  EmailSearchFieldAsyncTypeahead,
} from './EmailSearchField.styles';
import useImpersonation from './useImpersonation';
import { EmailSearchFieldProps } from './EmailSearchField.types';

const EmailSearchField: React.FC<EmailSearchFieldProps> = ({
  name,
  ...props
}) => {
  const { searchHandler } = useImpersonation();
  const { t } = useTranslation();

  return (
    // @ts-expect-error TS2769 [STRICT-MIGRATION] Temporarily suppressing strict type checking - should be fixed when this code is next modified
    <EmailSearchFieldAsyncTypeahead
      name={name}
      leftAddon={<Glyphicon glyph="search" />}
      placeholder={t('common.loginas.searchByEmail')}
      labelKey={(option: string) => option}
      searchHandler={searchHandler}
      renderMenuItemChildren={(option: string) => {
        return <EmailSearchOption>{option}</EmailSearchOption>;
      }}
      {...props}
    />
  );
};

export default EmailSearchField;
